
// import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
// import { useNavigate, useParams, useLocation, useSearchParams } from "react-router-dom";
// import "./McqOfTheDay.css";
// import InfoIcon  from "../../../Assets/Images/CommanImages/Informative.png";
// import ErrorIcon from "../../../Assets/Images/CommanImages/Error.png";
// import WarnningIcon from "../../../Assets/Images/CommanImages/Warning.png";
// import DropDownFilterTags      from "../QuestionPaperDetails/DropDownFilterTags";
// import SectionSelectedDropdown from "../QuestionPaperDetails/SectionSelectedDropdown";
// import MultiSelectSearchDropdown from "../SearchDropDown/MultiSelectSearchDropdown";
// import TableDetailsQuesList    from "../QuestionPaperDetails/TableDetailsQuesList";
// import TableDetailsSelectedQues from "./TableDetailsSelectedQuestions";
// import Endpoints from "../../../Api/Endpoints";

// const MAX_QUESTIONS = 3;

// // ─── McqOfTheDayEdit ─────────────────────────────────────────────────────────
// // Behaviour:
// //   • Page opens in VIEW mode:  all sections locked, buttons = [CANCEL] [DELETE] [EDIT]
// //   • EDIT clicked:             sections unlock, buttons = [CANCEL] [DELETE] [SAVE (disabled until change)]
// //   • Any question add/remove:  SAVE becomes enabled
// //   • Max 3 questions allowed;  selecting a 4th is blocked with a warning
// //   • Course dropdown is always locked (prefilled from dashboard)
// // ─────────────────────────────────────────────────────────────────────────────

// export default function McqOfTheDayEdit({
//   dataClient,
//   setMessageBox,
//   messageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   setNoTimeSet,
// }) {
//   const navigate       = useNavigate();
//   const location       = useLocation();
//   const params         = useParams();
//   const [searchParams] = useSearchParams();

//   const accessToken    = localStorage.getItem("other");
//   const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
//   const userId         = dataClient?.client_schema_name?.[6]?.[0]?.user_id           || null;

//   // ── Resolve context ───────────────────────────────────────────────────────
//   const routeState       = location.state || {};
//   const scheduleDate     =
//     routeState.scheduleDate  ||
//     params.date              ||
//     searchParams.get("date") ||
//     "";
//   const presetCourseId   =
//     routeState.courseId
//       ? String(routeState.courseId)
//       : searchParams.get("courseId") || "";
//   const presetCourse      = routeState.course      || searchParams.get("course")      || "";
//   const presetScheduledBy = routeState.scheduledBy || searchParams.get("scheduledBy") || "";

//   // ── Edit mode state ───────────────────────────────────────────────────────
//   const [isEditMode,   setIsEditMode]   = useState(false);
//   const [hasChanges,   setHasChanges]   = useState(false);

//   // snapshot of question IDs when edit mode is entered — used to detect changes
//   const snapshotRef = useRef([]);

//   // ── Accordion ─────────────────────────────────────────────────────────────
//   const [isOpenSubjectTags, setIsOpenSubjectTags] = useState(true);

//   // ── Filter state ──────────────────────────────────────────────────────────
//   const [courses,  setCourses]  = useState([]);
//   const [subjects, setSubjects] = useState([]);
//   const [chapters, setChapters] = useState([]);

//   // ── Derive courseId from presetCourseId (if present) or by matching
//   //    presetCourse name against the loaded courses list
//   const selectedCourseId = useMemo(() => {
//     if (presetCourseId) return presetCourseId;
//     if (!presetCourse || !courses.length) return "";
//     const match = courses.find(
//       (c) => c.course_name.trim().toLowerCase() === presetCourse.trim().toLowerCase()
//     );
//     return match ? String(match.course_id) : "";
//   }, [presetCourseId, presetCourse, courses]);

//   const [selectedSubjectId,  setSelectedSubjectId]  = useState("");
//   const [selectedChapterIds, setSelectedChapterIds] = useState([]);
//   const [selectedTopicIds,   setSelectedTopicIds]   = useState([]);
//   const [topicsByChapter,    setTopicsByChapter]    = useState({});
//   const [topicNameMap,       setTopicNameMap]       = useState({});
//   const [allTopicsLoaded,    setAllTopicsLoaded]    = useState(false);

//   const [tags,         setTags]         = useState([]);
//   const [selectedTags, setSelectedTags] = useState([]);

//   // ── Question list state ───────────────────────────────────────────────────
//   const [reportDashboardData,  setReportDashboardData]  = useState([]);
//   const [selectedQuestions,    setSelectedQuestions]    = useState([]);
//   const [selectedHeaders,      setSelectedHeaders]      = useState([]);
//   const [selectedRows,         setSelectedRows]         = useState([]);
//   const [difficultyCount,      setDifficultyCount]      = useState({});
//   const [showFlagModal,        setShowFlagModal]        = useState(false);
//   const [version,              setVersion]              = useState(0);
//   const [sectionWiseQuestions, setSectionWiseQuestions] = useState({});

//   // ── Pre-populate state ────────────────────────────────────────────────────
//   const [isFetchingExisting,    setIsFetchingExisting]    = useState(false);
//   const [existingQuestionCount, setExistingQuestionCount] = useState(0);

//   // Fixed localStorage key for the whole session
//   const activeSubjectKey = "mcqday";

//   // Single-date section option
//   const customSectionOptions = useMemo(
//     () => (scheduleDate ? [{ id: scheduleDate, label: scheduleDate }] : []),
//     [scheduleDate]
//   );

//   // ── Live selected count ───────────────────────────────────────────────────
//   const [selectedCount, setSelectedCount] = useState(0);
//   useEffect(() => {
//     const m = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
//     setSelectedCount((m[activeSubjectKey] || []).length);
//   }, [version]);

//   // ── Detect changes after edit mode is entered ─────────────────────────────
//   const checkForChanges = useCallback(() => {
//     if (!isEditMode) return;

//     const selMap = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
//     const delMap = JSON.parse(localStorage.getItem("subjectWiseDeletedRowIds")  || "{}");

//     const currentIds  = (selMap[activeSubjectKey] || []).map(String);
//     const deletedIds  = (delMap[activeSubjectKey] || []).map(String);
//     const snapshotIds = snapshotRef.current.map(String);

//     const effectiveIds = currentIds.filter((id) => !deletedIds.includes(id)).sort().join(",");
//     const snapSorted   = [...snapshotIds].sort().join(",");

//     setHasChanges(effectiveIds !== snapSorted);
//   }, [isEditMode]);

//   useEffect(() => { checkForChanges(); }, [version, isEditMode]);

//   useEffect(() => {
//     const onStorage = (e) => {
//       if (
//         e.key === "subjectWiseDeletedRowIds" ||
//         e.key === "subjectWiseSelectedRowIds"
//       ) {
//         checkForChanges();
//       }
//     };
//     window.addEventListener("storage", onStorage);
//     return () => window.removeEventListener("storage", onStorage);
//   }, [checkForChanges]);

//   useEffect(() => {
//     if (!isEditMode) return;
//     const interval = setInterval(checkForChanges, 300);
//     return () => clearInterval(interval);
//   }, [isEditMode, checkForChanges]);

//   // ── Version bump with MAX_QUESTIONS guard ─────────────────────────────────
//   const handleVersionChange = useCallback(
//     (updater) => {
//       const newVersion = typeof updater === "function" ? updater(version) : updater;

//       const m   = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
//       const cur = (m[activeSubjectKey] || []).length;

//       if (cur > MAX_QUESTIONS) {
//         const ids = m[activeSubjectKey] || [];
//         m[activeSubjectKey] = ids.slice(0, MAX_QUESTIONS);
//         localStorage.setItem("subjectWiseSelectedRowIds", JSON.stringify(m));

//         setActiveImg(WarnningIcon);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <span>
//                 Maximum <strong>{MAX_QUESTIONS}</strong> questions allowed per date.
//                 Please remove a question before adding another.
//               </span>
//             </div>
//             <div className="messagebox-insider2" style={{ marginTop: 10 }}>
//               <button
//                 className="messagebox-cancel-btn-ok"
//                 onMouseEnter={(e) => { e.target.style.backgroundColor = "#424342"; e.target.style.color = "white"; e.target.style.borderColor = "#424342"; }}
//                 onMouseLeave={(e) => { e.target.style.backgroundColor = "white"; e.target.style.color = "#424342"; e.target.style.borderColor = ""; }}
//                 onClick={() => setIsMessageBoxVisible(false)}
//               >
//                 OK
//               </button>
//             </div>
//           </div>
//         );
//         setIsMessageBoxVisible(true);
//         setVersion(newVersion);
//         return;
//       }

//       setVersion(newVersion);
//     },
//     [version, setActiveImg, setMessageBox, setIsMessageBoxVisible]
//   );

//   // ── Filters ───────────────────────────────────────────────────────────────
//   const getTopicsForChapter = useCallback((chapterId) => {
//     const allForChapter = topicsByChapter[chapterId] || [];
//     if (selectedTopicIds.length === 0) return allForChapter;
//     return selectedTopicIds.filter((tid) => allForChapter.includes(tid));
//   }, [selectedTopicIds, topicsByChapter]);

//   const filters = useMemo(() => {
//     if (!selectedSubjectId || !allTopicsLoaded) return [];
//     const chapsToUse = selectedChapterIds.length > 0
//       ? chapters.filter((ch) => selectedChapterIds.includes(ch.chapter_id))
//       : chapters;
//     if (!chapsToUse.length) return [];
//     const chapList = chapsToUse.map((ch) => ({
//       chapter_id: ch.chapter_id,
//       topics: getTopicsForChapter(ch.chapter_id),
//     }));
//     if (!chapList.some((c) => c.topics.length > 0)) return [];
//     return [{ ques_types: [{ ques_type_id: 1, chapters: chapList }] }];
//   }, [selectedSubjectId, selectedChapterIds, selectedTopicIds, chapters, topicsByChapter, allTopicsLoaded, getTopicsForChapter]);

//   const memoizedTags    = useMemo(() => selectedTags, [JSON.stringify(selectedTags)]);
//   const memoizedFilters = useMemo(() => filters,       [JSON.stringify(filters)]);

//   // ── API: courses ──────────────────────────────────────────────────────────
//   useEffect(() => {
//     if (!accessToken) return;
//     fetch(Endpoints.PRISM_GET_COURSES, { headers: { Authorization: `Bearer ${accessToken}` } })
//       .then((r) => r.json())
//       .then((d) => setCourses(Array.isArray(d) ? d : d?.data || []));
//   }, [accessToken]);

//   // ── API: subjects ─────────────────────────────────────────────────────────
//   useEffect(() => {
//     setSubjects([]);
//     setSelectedSubjectId("");
//     setChapters([]);
//     setSelectedChapterIds([]);
//     setSelectedTopicIds([]);
//     setTopicsByChapter({});
//     setAllTopicsLoaded(false);
//     if (!selectedCourseId || !accessToken) return;
//     fetch(
//       `${Endpoints.PRISM_GET_SUBJECTS_BY_COURSE}?course_id=${selectedCourseId}`,
//       { headers: { Authorization: `Bearer ${accessToken}` } }
//     )
//       .then((r) => r.json())
//       .then((d) => setSubjects(Array.isArray(d) ? d : d?.data || []));
//   }, [selectedCourseId]);

//   // ── API: chapters ─────────────────────────────────────────────────────────
//   useEffect(() => {
//     setChapters([]);
//     setSelectedChapterIds([]);
//     setSelectedTopicIds([]);
//     setTopicsByChapter({});
//     setAllTopicsLoaded(false);
//     if (!selectedSubjectId || !accessToken) return;
//     fetch(
//       `${Endpoints.PRISM_GET_CHAPTERS_BY_SUBJECT}?subject_superset_id=${selectedSubjectId}`,
//       { headers: { Authorization: `Bearer ${accessToken}` } }
//     )
//       .then((r) => r.json())
//       .then((d) => {
//         const list = Array.isArray(d) ? d : d?.data || [];
//         setChapters(list);
//         setSelectedChapterIds(list.map((ch) => ch.chapter_id));
//       });
//   }, [selectedSubjectId]);

//   // ── API: topics ───────────────────────────────────────────────────────────
//   useEffect(() => {
//     if (!chapters.length || !accessToken) {
//       setTopicsByChapter({}); setTopicNameMap({}); setAllTopicsLoaded(false); return;
//     }
//     setAllTopicsLoaded(false);
//     let completed = 0;
//     const result = {};
//     const nameMap = {};
//     chapters.forEach((ch) => {
//       fetch(`${Endpoints.PRISM_GET_TOPICS_BY_CHAPTER}?chapter_id=${ch.chapter_id}`, {
//         headers: { Authorization: `Bearer ${accessToken}` },
//       })
//         .then((r) => r.json())
//         .then((data) => {
//           const topicList = Array.isArray(data) ? data : data?.data || [];
//           result[ch.chapter_id] = topicList.map((t) => t.topic_id);
//           topicList.forEach((t) => { nameMap[t.topic_id] = t.topic_name; });
//           completed++;
//           if (completed === chapters.length) {
//             setTopicsByChapter({ ...result });
//             setTopicNameMap({ ...nameMap });
//             setSelectedTopicIds(Object.values(result).flat());
//             setAllTopicsLoaded(true);
//           }
//         })
//         .catch(() => {
//           completed++;
//           if (completed === chapters.length) {
//             setTopicsByChapter({ ...result });
//             setTopicNameMap({ ...nameMap });
//             setAllTopicsLoaded(true);
//           }
//         });
//     });
//   }, [chapters]);

//   // ── API: tags ─────────────────────────────────────────────────────────────
//   useEffect(() => {
//     if (!accessToken) return;
//     fetch(Endpoints.PRISM_GET_PARSE_TAGS_ALL, { headers: { Authorization: `Bearer ${accessToken}` } })
//       .then((r) => r.json())
//       .then((d) => { if (d.data) setTags(d.data); });
//   }, [accessToken]);

//   // ── API: pre-populate existing questions ──────────────────────────────────
//   // course_id is no longer required by the API — fetch all and filter by
//   // scheduleDate + presetCourse (name) client-side.
//   useEffect(() => {
//     if (!scheduleDate || !accessToken) return;

//     setIsFetchingExisting(true);

//     fetch(
//       Endpoints.PRISM_GET_ALL_MCQ_OF_DAY_BY_COURSE,
//       { headers: { Authorization: `Bearer ${accessToken}` } }
//     )
//       .then((r) => r.json())
//       .then((data) => {
//         const DATE_IDX   = 0;
//         const COURSE_IDX = 2;
//         const ID_IDX     = 4;

//         const dataRows = Array.isArray(data.headers)
//           ? data.headers.filter(Array.isArray)
//           : [];

//         const matchingRows = dataRows.filter((row) => {
//           const rowDate   = row[DATE_IDX]   ? String(row[DATE_IDX]).split(" ")[0] : "";
//           const rowCourse = row[COURSE_IDX] ? String(row[COURSE_IDX])             : "";
//           const dateMatch   = rowDate === scheduleDate;
//           const courseMatch = presetCourse
//             ? rowCourse.trim().toLowerCase() === presetCourse.trim().toLowerCase()
//             : true;
//           return dateMatch && courseMatch;
//         });

//         const questionIds = matchingRows.map((row) => row[ID_IDX]).filter((id) => id != null);
//         setExistingQuestionCount(questionIds.length);

//         if (questionIds.length > 0) {
//           const key    = String(activeSubjectKey);
//           const selMap = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
//           selMap[key]  = [...new Set([...(selMap[key] || []), ...questionIds])];
//           localStorage.setItem("subjectWiseSelectedRowIds", JSON.stringify(selMap));

//           const delMap = JSON.parse(localStorage.getItem("subjectWiseDeletedRowIds") || "{}");
//           delete delMap[key];
//           localStorage.setItem("subjectWiseDeletedRowIds", JSON.stringify(delMap));

//           snapshotRef.current = [...questionIds];
//           setVersion((v) => v + 1);
//         }
//       })
//       .catch((err) => console.error("McqOfTheDayEdit: failed to load existing questions:", err))
//       .finally(() => setIsFetchingExisting(false));
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [scheduleDate, accessToken]);

//   // ── Tag handlers ──────────────────────────────────────────────────────────
//   const handleDropdownChange = (tag, opt) =>
//     setSelectedTags((prev) => {
//       const f = prev.filter((t) => t.tag_id !== tag.parse_tag_id);
//       return opt?.id != null ? [...f, { tag_id: tag.parse_tag_id, tag_value_id: opt.id }] : f;
//     });

//   const handleCheckboxChange = (tag, checked) =>
//     setSelectedTags((prev) => {
//       const f = prev.filter((t) => t.tag_id !== tag.parse_tag_id);
//       return checked ? [...f, { tag_id: tag.parse_tag_id, tag_value_id: 1 }] : f;
//     });

//   // ── Enter edit mode ───────────────────────────────────────────────────────
//   const handleEditClick = () => {
//     const selMap = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
//     const delMap = JSON.parse(localStorage.getItem("subjectWiseDeletedRowIds")  || "{}");
//     const selected = (selMap[activeSubjectKey] || []).map(String);
//     const deleted  = (delMap[activeSubjectKey] || []).map(String);
//     snapshotRef.current = selected.filter((id) => !deleted.includes(id));

//     delete delMap[activeSubjectKey];
//     localStorage.setItem("subjectWiseDeletedRowIds", JSON.stringify(delMap));

//     setHasChanges(false);
//     setIsEditMode(true);
//   };

//   // ── Delete ────────────────────────────────────────────────────────────────
//   const handleDelete = () => {
//     setActiveImg(WarnningIcon);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <span>
//             Are you sure you want to delete all MCQ questions scheduled for{" "}
//             <strong>{scheduleDate}</strong>?
//           </span>
//         </div>
//         <div className="messagebox-insider2" style={{ marginTop: 10, display: "flex", gap: 10 }}>
//           <button
//             className="messagebox-cancel-btn-ok"
//             onMouseEnter={(e) => { e.target.style.backgroundColor = "#fa4741"; e.target.style.color = "white"; e.target.style.borderColor = "#fa4741"; }}
//             onMouseLeave={(e) => { e.target.style.backgroundColor = "white"; e.target.style.color = "#424342"; e.target.style.borderColor = ""; }}
//             onClick={async () => {
//               setIsMessageBoxVisible(false);
//               try {
//                 const res = await fetch(Endpoints.PRISM_DELETE_MCQ_SCHEDULE, {
//                   method: "DELETE",
//                   headers: {
//                     Authorization: `Bearer ${accessToken}`,
//                     "Content-Type": "application/json",
//                   },
//                   body: JSON.stringify({
//                     scheduled_date: scheduleDate,
//                     course_id: selectedCourseId ? parseInt(selectedCourseId) : 0,
//                   }),
//                 });
//                 const data = await res.json();
//                 if (data.status === 200) {
//                   setActiveImg(InfoIcon);
//                   setMessageBox(
//                     <div className="Container-messageBOX">
//                       <div className="messagebox-insider1">
//                         <span>{data.message || "MCQ schedule deleted successfully."}</span>
//                       </div>
//                     </div>
//                   );
//                   setIsMessageBoxVisible(true);
//                   setTimeout(() => {
//                     setIsMessageBoxVisible(false);
//                     navigate("/mcq_dashboard");
//                   }, 1500);
//                 } else {
//                   setActiveImg(ErrorIcon);
//                   setMessageBox(
//                     <div className="Container-messageBOX">
//                       <div className="messagebox-insider1">
//                         <span>{data.message || "Failed to delete MCQ schedule."}</span>
//                       </div>
//                       <div className="messagebox-insider2" style={{ marginTop: 10 }}>
//                         <button
//                           className="messagebox-cancel-btn-ok"
//                           onMouseEnter={(e) => { e.target.style.backgroundColor = "#424342"; e.target.style.color = "white"; e.target.style.borderColor = "#424342"; }}
//                           onMouseLeave={(e) => { e.target.style.backgroundColor = "white"; e.target.style.color = "#424342"; e.target.style.borderColor = ""; }}
//                           onClick={() => setIsMessageBoxVisible(false)}
//                         >
//                           OK
//                         </button>
//                       </div>
//                     </div>
//                   );
//                   setIsMessageBoxVisible(true);
//                 }
//               } catch (err) {
//                 console.error("McqOfTheDayEdit: delete failed:", err);
//                 setActiveImg(ErrorIcon);
//                 setMessageBox(
//                   <div className="Container-messageBOX">
//                     <div className="messagebox-insider1">
//                       <span>Something went wrong. Please try again.</span>
//                     </div>
//                     <div className="messagebox-insider2" style={{ marginTop: 10 }}>
//                       <button
//                         className="messagebox-cancel-btn-ok"
//                         onMouseEnter={(e) => { e.target.style.backgroundColor = "#424342"; e.target.style.color = "white"; e.target.style.borderColor = "#424342"; }}
//                         onMouseLeave={(e) => { e.target.style.backgroundColor = "white"; e.target.style.color = "#424342"; e.target.style.borderColor = ""; }}
//                         onClick={() => setIsMessageBoxVisible(false)}
//                       >
//                         OK
//                       </button>
//                     </div>
//                   </div>
//                 );
//                 setIsMessageBoxVisible(true);
//               }
//             }}
//           >
//             YES
//           </button>
//           <button
//             className="messagebox-cancel-btn-ok"
//             onMouseEnter={(e) => { e.target.style.backgroundColor = "#424342"; e.target.style.color = "white"; e.target.style.borderColor = "#424342"; }}
//             onMouseLeave={(e) => { e.target.style.backgroundColor = "white"; e.target.style.color = "#424342"; e.target.style.borderColor = ""; }}
//             onClick={() => setIsMessageBoxVisible(false)}
//           >
//             NO
//           </button>
//         </div>
//       </div>
//     );
//     setIsMessageBoxVisible(true);
//   };

//   // ── Save ──────────────────────────────────────────────────────────────────
//   const handleSave = () => {
//     if (selectedCount === 0) {
//       setActiveImg(ErrorIcon);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>Please select at least one question before saving.</span>
//           </div>
//           <div className="messagebox-insider2" style={{ marginTop: 10 }}>
//             <button
//               className="messagebox-cancel-btn-ok"
//               onMouseEnter={(e) => { e.target.style.backgroundColor = "#424342"; e.target.style.color = "white"; e.target.style.borderColor = "#424342"; }}
//               onMouseLeave={(e) => { e.target.style.backgroundColor = "white"; e.target.style.color = "#424342"; e.target.style.borderColor = ""; }}
//               onClick={() => setIsMessageBoxVisible(false)}
//             >
//               OK
//             </button>
//           </div>
//         </div>
//       );
//       setIsMessageBoxVisible(true);
//       return;
//     }

//     // TODO: call PRISM_UPDATE_MCQ_OF_DAY with scheduleDate + question IDs + courseId

//     setActiveImg(InfoIcon);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <span>
//             MCQ of the Day for <strong>{scheduleDate}</strong> updated successfully!
//           </span>
//         </div>
//         <div className="messagebox-insider2" style={{ marginTop: 10 }}>
//           <button
//             className="messagebox-cancel-btn-ok"
//             onMouseEnter={(e) => { e.target.style.backgroundColor = "#424342"; e.target.style.color = "white"; e.target.style.borderColor = "#424342"; }}
//             onMouseLeave={(e) => { e.target.style.backgroundColor = "white"; e.target.style.color = "#424342"; e.target.style.borderColor = ""; }}
//             onClick={() => { setIsMessageBoxVisible(false); }}
//           >
//             OK
//           </button>
//         </div>
//       </div>
//     );
//     setIsMessageBoxVisible(true);
//   };

//   // ── Shared locked overlay style ───────────────────────────────────────────
//   const lockedSection = !isEditMode
//     ? { opacity: 0.5, pointerEvents: "none", userSelect: "none" }
//     : {};

//   // ─────────────────────────────────────────────────────────────────────────
//   return (
//     <div className="create-role-container">

//       {/* ── Top bar ────────────────────────────────────────────────────── */}
//       <div className="create-role-container-ques-paper-del">
//         <div style={{ display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
//           <span className="create-role-heading">MCQ of the Day</span>
//           {isFetchingExisting && (
//             <span style={{ fontSize: 13, color: "#6a6a6a", fontStyle: "italic" }}>
//               Loading…
//             </span>
//           )}
//         </div>

//         {/* Buttons: CANCEL | DELETE | EDIT or SAVE */}
//         <div className="create-test-section-btns-container-ques-paper-dels">
//           <button
//             className="create-test-section-btn-ques-paper-del"
//             onClick={() => navigate("/mcq_dashboard")}
//           >
//             CANCEL
//           </button>

//           <button
//             className="create-test-section-btn-ques-paper-del"
//             onClick={handleDelete}
//             onMouseEnter={(e) => {
//               e.target.style.backgroundColor = "#fa4741";
//               e.target.style.color = "white";
//             }}
//             onMouseLeave={(e) => {
//               e.target.style.backgroundColor = "white";
//               e.target.style.color = "#424342";
//             }}
//           >
//             DELETE
//           </button>

//           {!isEditMode ? (
//             <button
//               className="create-test-section-btn-ques-paper-del"
//               style={{ marginRight: 0, boxShadow: "0px 4px 4px 0px #00000040" }}
//               onClick={handleEditClick}
//               onMouseEnter={(e) => {
//                 e.target.style.backgroundColor = "#424342";
//                 e.target.style.color = "white";
//               }}
//               onMouseLeave={(e) => {
//                 e.target.style.backgroundColor = "white";
//                 e.target.style.color = "#424342";
//               }}
//             >
//               EDIT
//             </button>
//           ) : (
//             <button
//               className="create-test-section-btn-ques-paper-del"
//               style={{
//                 marginRight: 0,
//                 boxShadow: "0px 4px 4px 0px #00000040",
//                 opacity: hasChanges ? 1 : 0.45,
//                 cursor: hasChanges ? "pointer" : "not-allowed",
//               }}
//               onClick={hasChanges ? handleSave : undefined}
//               onMouseEnter={(e) => {
//                 if (!hasChanges) return;
//                 e.target.style.backgroundColor = "#fa4741";
//                 e.target.style.color = "white";
//               }}
//               onMouseLeave={(e) => {
//                 e.target.style.backgroundColor = "white";
//                 e.target.style.color = "#424342";
//               }}
//             >
//               SAVE
//             </button>
//           )}
//         </div>
//       </div>

//       {/* ── SECTION 1: Subject & Tags Filter ──────────────────────────── */}
//       <div className="display-ques-paper-del" style={{ marginTop: 20 }}>
//         <div className="personal-header">
//           <div className="header">
//             <label>SUBJECT &amp; TAGS FILTER</label>
//           </div>
//           <div className="accordion-btn" onClick={() => setIsOpenSubjectTags((o) => !o)}>
//             {isOpenSubjectTags ? <div className="minus" /> : <div className="plus">+</div>}
//           </div>
//         </div>

//         {isOpenSubjectTags && (
//           <div className="accordion-content" style={lockedSection}>
//             <div className="motd-grid-3">
//               {/* Course — always locked / prefilled */}
//               <div style={{ opacity: 0.6, pointerEvents: "none", userSelect: "none" }}>
//                 <SectionSelectedDropdown
//                   label="Course"
//                   selected={selectedCourseId}
//                   setSelected={() => {}}
//                   options={courses.map((c) => ({ id: String(c.course_id), label: c.course_name }))}
//                   Height="auto" OverFlow="auto" minheight="300px"
//                 />
//               </div>

//               <SectionSelectedDropdown
//                 label="Subject"
//                 selected={selectedSubjectId}
//                 setSelected={(v) => { setSelectedSubjectId(v); setSelectedChapterIds([]); setSelectedTopicIds([]); }}
//                 options={subjects.map((s) => ({ id: String(s.subject_superset_id), label: s.subject_superset_name }))}
//                 Height="auto" OverFlow="auto" minheight="300px"
//                 disabled={!selectedCourseId}
//               />
//               <MultiSelectSearchDropdown
//                 label="Chapter"
//                 selected={selectedChapterIds}
//                 setSelected={(ids) => {
//                   setSelectedChapterIds(ids);
//                   const allTopics = ids.flatMap((cid) => topicsByChapter[cid] || []);
//                   setSelectedTopicIds([...new Set(allTopics)]);
//                 }}
//                 options={chapters.map((ch) => ({ id: ch.chapter_id, label: ch.chapter_name }))}
//                 showSelectAll
//                 disabled={!selectedSubjectId}
//                 placeholder={allTopicsLoaded ? "" : chapters.length ? "Loading…" : ""}
//               />
//               <MultiSelectSearchDropdown
//                 label="Topic"
//                 selected={selectedTopicIds}
//                 setSelected={setSelectedTopicIds}
//                 options={
//                   (selectedChapterIds.length > 0 ? selectedChapterIds : chapters.map((ch) => ch.chapter_id))
//                     .flatMap((cid) => (topicsByChapter[cid] || []).map((tid) => ({
//                       id: tid,
//                       label: topicNameMap[tid] || String(tid),
//                     })))
//                     .filter((opt, idx, arr) => arr.findIndex((o) => o.id === opt.id) === idx)
//                 }
//                 showSelectAll
//                 disabled={!selectedSubjectId}
//                 placeholder={allTopicsLoaded ? "" : chapters.length ? "Loading…" : ""}
//               />
//               {tags
//                 .filter((tag) => tag.parse_tag_type === 1 && tag.parse_tag_id !== 8)
//                 .map((tag) => (
//                   <div key={tag.parse_tag_id}>
//                     <DropDownFilterTags
//                       label={tag.parse_tag_name}
//                       setSelected={(opt) => handleDropdownChange(tag, opt)}
//                       options={tag.parse_tag_value.map((v) => ({ label: v.tag_value, id: v.parse_tag_value_id }))}
//                       selected={selectedTags.find((t) => t.tag_id === tag.parse_tag_id)?.tag_value_id || null}
//                     />
//                   </div>
//                 ))}
//             </div>

//             <div className="motd-section-divider" />

//             <div className="display-test-data-container-ques-paper-del-filter-tags">
//               <div className="display-grid-container-ques-paper-del-filter-tags">
//                 {tags
//                   .filter((tag) => tag.parse_tag_type === 2)
//                   .map((tag) => (
//                     <div className="grid-item" key={tag.parse_tag_id}>
//                       <div className="check-box-tag-impt">
//                         <input
//                           type="checkbox"
//                           id={`motd-edit-chk-${tag.parse_tag_id}`}
//                           className="cr-custom-checkbox-tags"
//                           onChange={(e) => handleCheckboxChange(tag, e.target.checked)}
//                           checked={selectedTags.some(
//                             (t) => t.tag_id === tag.parse_tag_id && t.tag_value_id === 1
//                           )}
//                         />
//                         <label htmlFor={`motd-edit-chk-${tag.parse_tag_id}`}>
//                           {tag.parse_tag_name}
//                         </label>
//                       </div>
//                     </div>
//                   ))}
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* ── SECTION 2: Questions List ──────────────────────────────────── */}
//       <div className="create-ques-paper-ques-list-container-text" style={{ marginTop: 20 }}>
//         <span>QUESTIONS LIST</span>
//       </div>
//       <div className="create-ques-paper-ques-list-container" style={lockedSection}>
//         <TableDetailsQuesList
//           selectedTags={memoizedTags}
//           filters={memoizedFilters}
//           setMessageBox={setMessageBox}
//           messageBox={messageBox}
//           setIsMessageBoxVisible={setIsMessageBoxVisible}
//           setActiveImg={setActiveImg}
//           setNoTimeSet={setNoTimeSet}
//           dataClient={null}
//           setSelectedQuestions={setSelectedQuestions}
//           setSelectedHeaders={setSelectedHeaders}
//           setDifficultyCount={setDifficultyCount}
//           userId={userId}
//           showFlagModal={showFlagModal}
//           setShowFlagModal={setShowFlagModal}
//           subjectId={selectedSubjectId ? parseInt(selectedSubjectId) : null}
//           courseId={selectedCourseId  ? parseInt(selectedCourseId)  : null}
//           scopeRefIds={[0]}
//           setReportDashboardData={setReportDashboardData}
//           reportDashboardData={reportDashboardData}
//           draftData={null}
//           selectedRows={selectedRows}
//           setSelectedRows={setSelectedRows}
//           selectedQuestions={selectedQuestions}
//           activeSubjectId={activeSubjectKey}
//           setVersion={handleVersionChange}
//           excludeRepeatCount={0}
//           clientBranchId={clientBranchId}
//           scopeId={0}
//           loadingTab={false}
//           setLoadingTab={() => {}}
//           isReadOnly={!isEditMode}
//         />
//       </div>

//       {/* ── SECTION 3: Selected Questions ─────────────────────────────── */}
//       <div className="create-ques-paper-ques-selected-container-text" style={{ marginTop: 20 }}>
//         <span>SELECTED QUESTIONS</span>
//       </div>
//       <div className="create-ques-paper-ques-selected-container" style={lockedSection}>
//         <TableDetailsSelectedQues
//           selectedQuestions={selectedQuestions}
//           selectedHeaders={selectedHeaders}
//           selectedSections={1}
//           setSectionWiseQuestions={setSectionWiseQuestions}
//           selecteSectionTypeID={1}
//           setIsMessageBoxVisible={setIsMessageBoxVisible}
//           setActiveImg={setActiveImg}
//           setMessageBox={setMessageBox}
//           allQuesList={reportDashboardData}
//           setSelectedQuestions={setSelectedQuestions}
//           selectedRows={selectedRows}
//           setSelectedRows={setSelectedRows}
//           draftData={null}
//           isReadOnlyMode={!isEditMode}
//           setDifficultyCount={setDifficultyCount}
//           activeSubjectId={activeSubjectKey}
//           version={version}
//           setVersion={handleVersionChange}
//           sectionWiseQuestions={sectionWiseQuestions}
//           customSectionOptions={customSectionOptions}
//           sectionColumnLabel="Schedule Date"
//           numQuestionsPerDate={MAX_QUESTIONS}
//         />
//       </div>
//     </div>
//   );
// }































import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { useNavigate, useParams, useLocation, useSearchParams } from "react-router-dom";
import "./McqOfTheDay.css";
import InfoIcon    from "../../../Assets/Images/CommanImages/Informative.png";
import ErrorIcon   from "../../../Assets/Images/CommanImages/Error.png";
import WarnningIcon from "../../../Assets/Images/CommanImages/Warning.png";
import DropDownFilterTags       from "../QuestionPaperDetails/DropDownFilterTags";
import SectionSelectedDropdown  from "../QuestionPaperDetails/SectionSelectedDropdown";
import MultiSelectSearchDropdown from "../SearchDropDown/MultiSelectSearchDropdown";
import TableDetailsQuesList     from "../QuestionPaperDetails/TableDetailsQuesList";
import TableDetailsSelectedQues from "./TableDetailsSelectedQuestions";
import Endpoints from "../../../Api/Endpoints";
 
const MAX_QUESTIONS = 3;
 
// ─── McqOfTheDayEdit ──────────────────────────────────────────────────────────
// VIEW mode  → all locked, buttons: CANCEL | DELETE | EDIT
// EDIT mode  → unlocked,  buttons: CANCEL | DELETE | SAVE (disabled until change)
// Subjects can be switched; each subject retains its own selections via
// per-subject localStorage keys, exactly like the create page.
// ──────────────────────────────────────────────────────────────────────────────
 
export default function McqOfTheDayEdit({
  dataClient,
  setMessageBox,
  messageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  setNoTimeSet,
}) {
  const navigate       = useNavigate();
  const location       = useLocation();
  const params         = useParams();
  const [searchParams] = useSearchParams();
 
  const accessToken    = localStorage.getItem("other");
  const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
  const userId         = dataClient?.client_schema_name?.[6]?.[0]?.user_id           || null;
  const userName       = dataClient?.client_schema_name?.[6]?.[0]?.user_name         || "";
 
  // ── Resolve context from route ────────────────────────────────────────────
  const routeState       = location.state || {};
  const scheduleDate     =
    routeState.scheduleDate  ||
    params.date              ||
    searchParams.get("date") ||
    "";
  const presetCourseId   =
    routeState.courseId
      ? String(routeState.courseId)
      : searchParams.get("courseId") || "";
  const presetCourse      = routeState.course      || searchParams.get("course")      || "";
  const presetScheduledBy = routeState.scheduledBy || searchParams.get("scheduledBy") || "";
 
  // ── Edit / view mode ──────────────────────────────────────────────────────
  const [isEditMode, setIsEditMode] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
 
  // Snapshot of question IDs when edit mode is entered — used to detect changes
  const snapshotRef = useRef([]);
 
  // ── Accordion ─────────────────────────────────────────────────────────────
  const [isOpenSubjectTags, setIsOpenSubjectTags] = useState(true);
 
  // ── Filter state ──────────────────────────────────────────────────────────
  const [courses,  setCourses]  = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
 
  // Derive courseId: prefer explicit presetCourseId, else match by name
  const selectedCourseId = useMemo(() => {
    if (presetCourseId) return presetCourseId;
    if (!presetCourse || !courses.length) return "";
    const match = courses.find(
      (c) => c.course_name.trim().toLowerCase() === presetCourse.trim().toLowerCase()
    );
    return match ? String(match.course_id) : "";
  }, [presetCourseId, presetCourse, courses]);
 
  const [selectedSubjectId,  setSelectedSubjectId]  = useState("");
  const [selectedChapterIds, setSelectedChapterIds] = useState([]);
  const [selectedTopicIds,   setSelectedTopicIds]   = useState([]);
  const [topicsByChapter,    setTopicsByChapter]    = useState({});
  const [topicNameMap,       setTopicNameMap]       = useState({});
  const [allTopicsLoaded,    setAllTopicsLoaded]    = useState(false);
 
  const [tags,         setTags]         = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
 
  // ── Per-subject selection maps ────────────────────────────────────────────
  // Key: subjectId (or "mcqday"), Value: array of selected question objects.
  // Switching subjects retains each subject's selections.
  const [selectedQuestionsBySubject, setSelectedQuestionsBySubject] = useState({});
  const [selectedRowsBySubject,      setSelectedRowsBySubject]      = useState({});
  const [selectedHeadersBySubject,   setSelectedHeadersBySubject]   = useState({});
  const [reportDashboardData,  setReportDashboardData]  = useState([]);
  const [difficultyCount,      setDifficultyCount]      = useState({});
  const [showFlagModal,        setShowFlagModal]        = useState(false);
  const [version,              setVersion]              = useState(0);
  const [sectionWiseQuestions, setSectionWiseQuestions] = useState({});
 
  // Fixed localStorage key — edit page uses a single date, single slot
  const activeSubjectKey = selectedSubjectId ? parseInt(selectedSubjectId) : "mcqday";
 
  // Derived per-subject state for the CURRENT subject
  const selectedQuestions = selectedQuestionsBySubject[activeSubjectKey] || [];
  const selectedRows      = selectedRowsBySubject[activeSubjectKey]      || [];
  const selectedHeaders   = selectedHeadersBySubject[activeSubjectKey]   || [];
 
  const setSelectedQuestions = (qOrFn) =>
    setSelectedQuestionsBySubject((prev) => ({
      ...prev,
      [activeSubjectKey]: typeof qOrFn === "function" ? qOrFn(prev[activeSubjectKey] || []) : qOrFn,
    }));
  const setSelectedRows = (rOrFn) =>
    setSelectedRowsBySubject((prev) => ({
      ...prev,
      [activeSubjectKey]: typeof rOrFn === "function" ? rOrFn(prev[activeSubjectKey] || []) : rOrFn,
    }));
  const setSelectedHeaders = (hOrFn) =>
    setSelectedHeadersBySubject((prev) => ({
      ...prev,
      [activeSubjectKey]: typeof hOrFn === "function" ? hOrFn(prev[activeSubjectKey] || []) : hOrFn,
    }));
 
  // ── Pre-populate state ────────────────────────────────────────────────────
  const [isFetchingExisting,    setIsFetchingExisting]    = useState(false);
  const [existingQuestionCount, setExistingQuestionCount] = useState(0);
 
  // Single-date section option (one date = one slot)
  const customSectionOptions = useMemo(
    () => (scheduleDate ? [{ id: scheduleDate, label: scheduleDate }] : []),
    [scheduleDate]
  );
 
  // ── Live selected count — TOTAL across ALL subjects ───────────────────────
  const [selectedCount, setSelectedCount] = useState(0);
  useEffect(() => {
    const m = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
    const total = Object.values(m).reduce((sum, ids) => sum + (ids || []).length, 0);
    setSelectedCount(total);
  }, [version]);
 
  // ── Detect changes after edit mode is entered ─────────────────────────────
  const checkForChanges = useCallback(() => {
    if (!isEditMode) return;
    const selMap = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
    const delMap = JSON.parse(localStorage.getItem("subjectWiseDeletedRowIds")  || "{}");
 
    // Effective IDs = all selected across all subjects, minus deleted
    const allSelected = Object.values(selMap).flat().map(String);
    const allDeleted  = Object.values(delMap).flat().map(String);
    const effectiveIds = allSelected.filter((id) => !allDeleted.includes(id)).sort().join(",");
    const snapSorted   = [...snapshotRef.current].map(String).sort().join(",");
 
    setHasChanges(effectiveIds !== snapSorted);
  }, [isEditMode]);
 
  useEffect(() => { checkForChanges(); }, [version, isEditMode]);
 
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === "subjectWiseDeletedRowIds" || e.key === "subjectWiseSelectedRowIds") {
        checkForChanges();
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [checkForChanges]);
 
  useEffect(() => {
    if (!isEditMode) return;
    const interval = setInterval(checkForChanges, 300);
    return () => clearInterval(interval);
  }, [isEditMode, checkForChanges]);
 
  // ── Version bump with MAX_QUESTIONS guard ─────────────────────────────────
  const handleVersionChange = useCallback(
    (updater) => {
      const newVersion = typeof updater === "function" ? updater(version) : updater;
      const m   = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
      // Total across ALL subjects
      const cur = Object.values(m).reduce((sum, ids) => sum + (ids || []).length, 0);
 
      if (cur > MAX_QUESTIONS) {
        // Revert: pop the last added ID from the current subject's list
        const key = String(activeSubjectKey);
        const ids = m[key] || [];
        m[key] = ids.slice(0, -1);
        localStorage.setItem("subjectWiseSelectedRowIds", JSON.stringify(m));
 
        setActiveImg(WarnningIcon);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span>
                Maximum <strong>{MAX_QUESTIONS}</strong> questions allowed for this date.
                Please remove a question before adding another.
              </span>
            </div>
            <div className="messagebox-insider2" style={{ marginTop: 10 }}>
              <button
                className="messagebox-cancel-btn-ok"
                onClick={() => setIsMessageBoxVisible(false)}
              >
                OK
              </button>
            </div>
          </div>
        );
        setIsMessageBoxVisible(true);
        setVersion(newVersion);
        return;
      }
      setVersion(newVersion);
    },
    [version, activeSubjectKey, setActiveImg, setMessageBox, setIsMessageBoxVisible]
  );
 
  // ── Ref to guard stale chapter IDs across subject switches ────────────────
  const filterSubjectRef = useRef(null);
 
  // ── Filters ───────────────────────────────────────────────────────────────
  const getTopicsForChapter = useCallback((chapterId) => {
    const allForChapter = topicsByChapter[chapterId] || [];
    if (selectedTopicIds.length === 0) return allForChapter;
    return selectedTopicIds.filter((tid) => allForChapter.includes(tid));
  }, [selectedTopicIds, topicsByChapter]);
 
  const filters = useMemo(() => {
    if (!selectedSubjectId || !allTopicsLoaded) return [];
 
    // ── Stale chapter IDs guard ──────────────────────────────────────────────
    // If selectedChapterIds belong to a previous subject, return empty and wait
    if (selectedChapterIds.length > 0) {
      const chapterIdSet = new Set(chapters.map((ch) => ch.chapter_id));
      const allMatch = selectedChapterIds.every((id) => chapterIdSet.has(id));
      if (!allMatch) return [];
    }
 
    const chapsToUse = selectedChapterIds.length > 0
      ? chapters.filter((ch) => selectedChapterIds.includes(ch.chapter_id))
      : chapters;
    if (!chapsToUse.length) return [];
 
    const chapList = chapsToUse.map((ch) => ({
      chapter_id: ch.chapter_id,
      topics: getTopicsForChapter(ch.chapter_id), // empty array is fine
    }));
 
    // Removed: if (!chapList.some((c) => c.topics.length > 0)) return [];
    // Chapters with no topics are valid — questions API should still be called
 
    return [{ ques_types: [{ ques_type_id: 1, chapters: chapList }] }];
  }, [selectedSubjectId, selectedChapterIds, selectedTopicIds, chapters, topicsByChapter, allTopicsLoaded, getTopicsForChapter]);
 
  const memoizedTags    = useMemo(() => selectedTags, [JSON.stringify(selectedTags)]);
  const memoizedFilters = useMemo(() => filters,      [JSON.stringify(filters)]);
 
  // ── API: courses ──────────────────────────────────────────────────────────
  useEffect(() => {
    if (!accessToken) return;
    fetch(Endpoints.PRISM_GET_COURSES, { headers: { Authorization: `Bearer ${accessToken}` } })
      .then((r) => r.json())
      .then((d) => setCourses(Array.isArray(d) ? d : d?.data || []));
  }, [accessToken]);
 
  // ── API: subjects ─────────────────────────────────────────────────────────
  useEffect(() => {
    setSubjects([]); setSelectedSubjectId(""); setChapters([]);
    setSelectedChapterIds([]); setSelectedTopicIds([]); setTopicsByChapter({}); setAllTopicsLoaded(false);
    if (!selectedCourseId || !accessToken) return;
    fetch(`${Endpoints.PRISM_GET_SUBJECTS_BY_COURSE}?course_id=${selectedCourseId}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
      .then((r) => r.json())
      .then((d) => setSubjects(Array.isArray(d) ? d : d?.data || []));
  }, [selectedCourseId]);
 
  // ── API: chapters — auto-select all, guarded against stale switches ───────
  useEffect(() => {
    setChapters([]); setSelectedChapterIds([]); setSelectedTopicIds([]);
    setTopicsByChapter({}); setAllTopicsLoaded(false);
    filterSubjectRef.current = selectedSubjectId;
 
    if (!selectedSubjectId || !accessToken) return;
    fetch(`${Endpoints.PRISM_GET_CHAPTERS_BY_SUBJECT}?subject_superset_id=${selectedSubjectId}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
      .then((r) => r.json())
      .then((d) => {
        if (filterSubjectRef.current !== selectedSubjectId) return;
        const list = Array.isArray(d) ? d : d?.data || [];
        setChapters(list);
        setSelectedChapterIds(list.map((ch) => ch.chapter_id));
      });
  }, [selectedSubjectId]);
 
  // ── API: topics — parallel fetch per chapter + auto-select all ────────────
  useEffect(() => {
    if (!chapters.length || !accessToken) {
      setTopicsByChapter({}); setTopicNameMap({}); setAllTopicsLoaded(false); return;
    }
    setAllTopicsLoaded(false);
    let completed = 0;
    const result  = {};
    const nameMap = {};
    chapters.forEach((ch) => {
      fetch(`${Endpoints.PRISM_GET_TOPICS_BY_CHAPTER}?chapter_id=${ch.chapter_id}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      })
        .then((r) => r.json())
        .then((data) => {
          const topicList = Array.isArray(data) ? data : data?.data || [];
          result[ch.chapter_id] = topicList.map((t) => t.topic_id);
          topicList.forEach((t) => { nameMap[t.topic_id] = t.topic_name; });
          completed++;
          if (completed === chapters.length) {
            setTopicsByChapter({ ...result });
            setTopicNameMap({ ...nameMap });
            setSelectedTopicIds(Object.values(result).flat());
            setAllTopicsLoaded(true);
          }
        })
        .catch(() => {
          completed++;
          if (completed === chapters.length) {
            setTopicsByChapter({ ...result });
            setTopicNameMap({ ...nameMap });
            setAllTopicsLoaded(true);
          }
        });
    });
  }, [chapters]);
 
  // ── API: tags ─────────────────────────────────────────────────────────────
  useEffect(() => {
    if (!accessToken) return;
    fetch(Endpoints.PRISM_GET_PARSE_TAGS_ALL, { headers: { Authorization: `Bearer ${accessToken}` } })
      .then((r) => r.json())
      .then((d) => { if (d.data) setTags(d.data); });
  }, [accessToken]);
 
  // ── API: pre-populate existing questions for this date ────────────────────
  useEffect(() => {
    if (!scheduleDate || !accessToken) return;
    setIsFetchingExisting(true);
 
    fetch(Endpoints.PRISM_GET_ALL_MCQ_OF_DAY_BY_COURSE, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
      .then((r) => r.json())
      .then((data) => {
        const DATE_IDX   = 0;
        const COURSE_IDX = 2;
        const ID_IDX     = 4;
 
        const dataRows = Array.isArray(data.headers)
          ? data.headers.filter(Array.isArray)
          : [];
 
        const matchingRows = dataRows.filter((row) => {
          const rowDate   = row[DATE_IDX]   ? String(row[DATE_IDX]).split(" ")[0] : "";
          const rowCourse = row[COURSE_IDX] ? String(row[COURSE_IDX])             : "";
          const dateMatch   = rowDate === scheduleDate;
          const courseMatch = presetCourse
            ? rowCourse.trim().toLowerCase() === presetCourse.trim().toLowerCase()
            : true;
          return dateMatch && courseMatch;
        });
 
        const questionIds = matchingRows.map((row) => row[ID_IDX]).filter((id) => id != null);
        setExistingQuestionCount(questionIds.length);
 
        if (questionIds.length > 0) {
          // Store in localStorage under the fixed "mcqday" key
          const key    = "mcqday";
          const selMap = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
          selMap[key]  = [...new Set([...(selMap[key] || []), ...questionIds])];
          localStorage.setItem("subjectWiseSelectedRowIds", JSON.stringify(selMap));
 
          const delMap = JSON.parse(localStorage.getItem("subjectWiseDeletedRowIds") || "{}");
          delete delMap[key];
          localStorage.setItem("subjectWiseDeletedRowIds", JSON.stringify(delMap));
 
          // Also pre-fill mcqDateAssignments so the selected table shows the date
          const existing = JSON.parse(localStorage.getItem("mcqDateAssignments") || "{}");
          questionIds.forEach((id) => {
            if (!existing[String(id)]) {
              existing[String(id)] = scheduleDate;
            }
          });
          localStorage.setItem("mcqDateAssignments", JSON.stringify(existing));
 
          snapshotRef.current = [...questionIds];
          setVersion((v) => v + 1);
        }
      })
      .catch((err) => console.error("McqOfTheDayEdit: failed to load existing questions:", err))
      .finally(() => setIsFetchingExisting(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scheduleDate, accessToken]);
 
  // ── Tag handlers ──────────────────────────────────────────────────────────
  const handleDropdownChange = (tag, opt) =>
    setSelectedTags((prev) => {
      const f = prev.filter((t) => t.tag_id !== tag.parse_tag_id);
      return opt?.id != null ? [...f, { tag_id: tag.parse_tag_id, tag_value_id: opt.id }] : f;
    });
 
  const handleCheckboxChange = (tag, checked) =>
    setSelectedTags((prev) => {
      const f = prev.filter((t) => t.tag_id !== tag.parse_tag_id);
      return checked ? [...f, { tag_id: tag.parse_tag_id, tag_value_id: 1 }] : f;
    });
 
  // ── Enter edit mode ───────────────────────────────────────────────────────
  const handleEditClick = () => {
    const selMap = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
    const delMap = JSON.parse(localStorage.getItem("subjectWiseDeletedRowIds")  || "{}");
    const allSelected = Object.values(selMap).flat().map(String);
    const allDeleted  = Object.values(delMap).flat().map(String);
    snapshotRef.current = allSelected.filter((id) => !allDeleted.includes(id));
 
    // Clear deleted map so we start fresh in edit mode
    localStorage.setItem("subjectWiseDeletedRowIds", JSON.stringify({}));
 
    setHasChanges(false);
    setIsEditMode(true);
  };
 
  // ── Delete ────────────────────────────────────────────────────────────────
  const handleDelete = () => {
    setActiveImg(WarnningIcon);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <span>
            Are you sure you want to delete all MCQ questions scheduled for{" "}
            <strong>{scheduleDate}</strong>?
          </span>
        </div>
        <div className="messagebox-insider2" style={{ marginTop: 10, display: "flex", gap: 10 }}>
          <button
            className="messagebox-cancel-btn-ok"
            onClick={async () => {
              setIsMessageBoxVisible(false);
              try {
                const res = await fetch(Endpoints.PRISM_DELETE_MCQ_SCHEDULE, {
                  method: "DELETE",
                  headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    scheduled_date: scheduleDate,
                    course_id: selectedCourseId ? parseInt(selectedCourseId) : 0,
                  }),
                });
                const data = await res.json();
                if (data.status === 200) {
                  // ── Clear all MCQ localStorage on successful delete ────────────────
                  localStorage.removeItem("mcqDateAssignments");
                  localStorage.removeItem("subjectWiseSelectedRowIds");
                  localStorage.removeItem("subjectWiseDeletedRowIds");
 
                  setActiveImg(InfoIcon);
                  setMessageBox(
                    <div className="Container-messageBOX">
                      <div className="messagebox-insider1">
                        <span>{data.message || "MCQ schedule deleted successfully."}</span>
                      </div>
                    </div>
                  );
                  setIsMessageBoxVisible(true);
                  setTimeout(() => {
                    setIsMessageBoxVisible(false);
                    navigate("/mcq_dashboard");
                  }, 1500);
                } else {
                  setActiveImg(ErrorIcon);
                  setMessageBox(
                    <div className="Container-messageBOX">
                      <div className="messagebox-insider1">
                        <span>{data.message || "Failed to delete MCQ schedule."}</span>
                      </div>
                      <div className="messagebox-insider2" style={{ marginTop: 10 }}>
                        <button className="messagebox-cancel-btn-ok" onClick={() => setIsMessageBoxVisible(false)}>OK</button>
                      </div>
                    </div>
                  );
                  setIsMessageBoxVisible(true);
                }
              } catch (err) {
                console.error("McqOfTheDayEdit: delete failed:", err);
                setActiveImg(ErrorIcon);
                setMessageBox(
                  <div className="Container-messageBOX">
                    <div className="messagebox-insider1">
                      <span>Something went wrong. Please try again.</span>
                    </div>
                    <div className="messagebox-insider2" style={{ marginTop: 10 }}>
                      <button className="messagebox-cancel-btn-ok" onClick={() => setIsMessageBoxVisible(false)}>OK</button>
                    </div>
                  </div>
                );
                setIsMessageBoxVisible(true);
              }
            }}
          >
            YES
          </button>
          <button
            className="messagebox-cancel-btn-ok"
            onClick={() => setIsMessageBoxVisible(false)}
          >
            NO
          </button>
        </div>
      </div>
    );
    setIsMessageBoxVisible(true);
  };
 
  // ── Save — uses PRISM_CREATE_MCQ_SCHEDULE (same as create page) ───────────
  const handleSave = async () => {
    if (selectedCount === 0) {
      setActiveImg(ErrorIcon);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>Please select at least one question before saving.</span>
          </div>
          <div className="messagebox-insider2" style={{ marginTop: 10 }}>
            <button className="messagebox-cancel-btn-ok" onClick={() => setIsMessageBoxVisible(false)}>OK</button>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      return;
    }
 
    // Build schedule_data from sectionWiseQuestions (same structure as create page)
    const scheduleData = [];
    Object.entries(sectionWiseQuestions).forEach(([scheduledDate, questions]) => {
      questions.forEach((q) => {
        scheduleData.push({
          scheduled_date: scheduledDate,
          parse_ques_set_question_id: q.id,
          course_id: selectedCourseId ? parseInt(selectedCourseId) : 0,
        });
      });
    });
 
    if (scheduleData.length === 0) {
      setActiveImg(ErrorIcon);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>No questions assigned to the date. Please assign questions before saving.</span>
          </div>
          <div className="messagebox-insider2" style={{ marginTop: 10 }}>
            <button className="messagebox-cancel-btn-ok" onClick={() => setIsMessageBoxVisible(false)}>OK</button>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      return;
    }
 
    // Show loading
    setActiveImg(InfoIcon);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <span>Saving MCQ schedule...</span>
        </div>
      </div>
    );
    setIsMessageBoxVisible(true);
 
    try {
      const res = await fetch(Endpoints.PRISM_CREATE_MCQ_SCHEDULE, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          user_name: userName,
          schedule_data: scheduleData,
        }),
      });
      const data = await res.json();
 
      if (data.status === 200) {
        // ── Clear all MCQ localStorage on successful save ──────────────────
        localStorage.removeItem("mcqDateAssignments");
        localStorage.removeItem("subjectWiseSelectedRowIds");
        localStorage.removeItem("subjectWiseDeletedRowIds");
 
        setActiveImg(InfoIcon);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span>{data.message || `MCQ of the Day for ${scheduleDate} updated successfully!`}</span>
            </div>
            <div className="messagebox-insider2" style={{ marginTop: 10 }}>
              <button
                className="messagebox-cancel-btn-ok"
                onClick={() => {
                  setIsMessageBoxVisible(false);
                  navigate("/mcq_dashboard");
                }}
              >
                OK
              </button>
            </div>
          </div>
        );
        setIsMessageBoxVisible(true);
      } else {
        throw new Error(data.message || "Failed to save MCQ schedule");
      }
    } catch (err) {
      console.error("McqOfTheDayEdit: save failed:", err);
      setActiveImg(ErrorIcon);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>Failed to save MCQ schedule. Please try again. {err.message}</span>
          </div>
          <div className="messagebox-insider2" style={{ marginTop: 10 }}>
            <button className="messagebox-cancel-btn-ok" onClick={() => setIsMessageBoxVisible(false)}>OK</button>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
    }
  };
 
  // ── All selected questions merged across ALL subjects ─────────────────────
  const allSelectedQuestions = Object.values(selectedQuestionsBySubject).flat();
  const allSelectedRows      = Object.values(selectedRowsBySubject).flat();
 
  // ── Stable selected questions for the SELECTED table ─────────────────────
  // Built from localStorage so it survives subject switches without waiting
  // for the questions list to re-fetch and populate selectedQuestions state.
  const stableSelectedQuestions = useMemo(() => {
    const assignments = JSON.parse(localStorage.getItem("mcqDateAssignments") || "{}");
    const selMap      = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
    const allIds      = new Set(Object.values(selMap).flat().map(String));
    if (allIds.size === 0) return [];
    return Array.from(allIds).map((qid) => {
      const existingRow = allSelectedQuestions.find((r) => String(r[1]) === qid);
      if (existingRow) return existingRow;
      return ["", qid, qid, "", "", "", ""];
    });
  }, [version, allSelectedQuestions]);
 
  // ── Shared locked overlay style ───────────────────────────────────────────
  const lockedSection = !isEditMode
    ? { opacity: 0.5, pointerEvents: "none", userSelect: "none" }
    : {};
 
  // ─────────────────────────────────────────────────────────────────────────
  return (
    <div className="create-role-container">
 
      {/* ── Top bar ──────────────────────────────────────────────────────── */}
      <div className="create-role-container-ques-paper-del">
        <div style={{ display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
          <span className="create-role-heading">MCQ of the Day</span>
          {scheduleDate && (
            <span style={{ fontSize: 14, color: "#6a6a6a" }}>
              — {scheduleDate}
            </span>
          )}
          {isFetchingExisting && (
            <span style={{ fontSize: 13, color: "#6a6a6a", fontStyle: "italic" }}>
              Loading existing questions…
            </span>
          )}
        </div>
 
        <div className="create-test-section-btns-container-ques-paper-dels">
          {/* CANCEL */}
          <button
            className="create-test-section-btn-ques-paper-del"
            onClick={() => {
              localStorage.removeItem("mcqDateAssignments");
              localStorage.removeItem("subjectWiseSelectedRowIds");
              localStorage.removeItem("subjectWiseDeletedRowIds");
              navigate("/mcq_dashboard");
            }}
          >
            CANCEL
          </button>
 
          {/* DELETE */}
          <button
            className="create-test-section-btn-ques-paper-del"
            onClick={handleDelete}
            onMouseEnter={(e) => { e.target.style.backgroundColor = "#fa4741"; e.target.style.color = "white"; }}
            onMouseLeave={(e) => { e.target.style.backgroundColor = "white"; e.target.style.color = "#424342"; }}
          >
            DELETE
          </button>
 
          {/* EDIT / SAVE */}
          {!isEditMode ? (
            <button
              className="create-test-section-btn-ques-paper-del"
              style={{ marginRight: 0, boxShadow: "0px 4px 4px 0px #00000040" }}
              onClick={handleEditClick}
              onMouseEnter={(e) => { e.target.style.backgroundColor = "#424342"; e.target.style.color = "white"; }}
              onMouseLeave={(e) => { e.target.style.backgroundColor = "white"; e.target.style.color = "#424342"; }}
            >
              EDIT
            </button>
          ) : (
            <button
              className="create-test-section-btn-ques-paper-del"
              style={{
                marginRight: 0,
                boxShadow: "0px 4px 4px 0px #00000040",
                opacity: hasChanges ? 1 : 0.45,
                cursor: hasChanges ? "pointer" : "not-allowed",
              }}
              onClick={hasChanges ? handleSave : undefined}
              onMouseEnter={(e) => {
                if (!hasChanges) return;
                e.target.style.backgroundColor = "#fa4741";
                e.target.style.color = "white";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "white";
                e.target.style.color = "#424342";
              }}
            >
              SAVE
            </button>
          )}
        </div>
      </div>
 
      {/* ── SECTION 1: Subject & Tags Filter ─────────────────────────────── */}
      <div className="display-ques-paper-del" style={{ marginTop: 20 }}>
        <div className="personal-header">
          <div className="header">
            <label>SUBJECT &amp; TAGS FILTER</label>
          </div>
          <div className="accordion-btn" onClick={() => setIsOpenSubjectTags((o) => !o)}>
            {isOpenSubjectTags ? <div className="minus" /> : <div className="plus">+</div>}
          </div>
        </div>
 
        {isOpenSubjectTags && (
          <div className="accordion-content" style={lockedSection}>
            <div className="motd-grid-3">
              {/* Course — always locked / prefilled */}
              <div style={{ opacity: 0.6, pointerEvents: "none", userSelect: "none" }}>
                <SectionSelectedDropdown
                  label="Course"
                  selected={selectedCourseId}
                  setSelected={() => {}}
                  options={courses.map((c) => ({ id: String(c.course_id), label: c.course_name }))}
                  Height="auto" OverFlow="auto" minheight="300px"
                />
              </div>
 
              <SectionSelectedDropdown
                label="Subject"
                selected={selectedSubjectId}
                setSelected={(v) => {
                  // Previous subject's questions are retained via per-subject localStorage key
                  setSelectedSubjectId(v);
                  setSelectedChapterIds([]);
                  setSelectedTopicIds([]);
                }}
                options={subjects.map((s) => ({ id: String(s.subject_superset_id), label: s.subject_superset_name }))}
                Height="auto" OverFlow="auto" minheight="300px"
                disabled={!selectedCourseId}
              />
 
              <MultiSelectSearchDropdown
                label="Chapter"
                selected={selectedChapterIds}
                setSelected={(ids) => {
                  setSelectedChapterIds(ids);
                  const allTopics = ids.flatMap((cid) => topicsByChapter[cid] || []);
                  setSelectedTopicIds([...new Set(allTopics)]);
                }}
                options={chapters.map((ch) => ({ id: ch.chapter_id, label: ch.chapter_name }))}
                showSelectAll
                disabled={!selectedSubjectId}
                placeholder={allTopicsLoaded ? "" : chapters.length ? "Loading…" : ""}
              />
 
              <MultiSelectSearchDropdown
                label="Topic"
                selected={selectedTopicIds}
                setSelected={setSelectedTopicIds}
                options={
                  (selectedChapterIds.length > 0 ? selectedChapterIds : chapters.map((ch) => ch.chapter_id))
                    .flatMap((cid) => (topicsByChapter[cid] || []).map((tid) => ({
                      id: tid,
                      label: topicNameMap[tid] || String(tid),
                    })))
                    .filter((opt, idx, arr) => arr.findIndex((o) => o.id === opt.id) === idx)
                }
                showSelectAll
                disabled={!selectedSubjectId}
                placeholder={allTopicsLoaded ? "" : chapters.length ? "Loading…" : ""}
              />
 
              {tags.filter((tag) => tag.parse_tag_type === 1 && tag.parse_tag_id !== 8).map((tag) => (
                <div key={tag.parse_tag_id}>
                  <DropDownFilterTags
                    label={tag.parse_tag_name}
                    setSelected={(opt) => handleDropdownChange(tag, opt)}
                    options={tag.parse_tag_value.map((v) => ({ label: v.tag_value, id: v.parse_tag_value_id }))}
                    selected={selectedTags.find((t) => t.tag_id === tag.parse_tag_id)?.tag_value_id || null}
                  />
                </div>
              ))}
            </div>
 
            <div className="motd-section-divider" />
 
            <div className="display-test-data-container-ques-paper-del-filter-tags">
              <div className="display-grid-container-ques-paper-del-filter-tags">
                {tags.filter((tag) => tag.parse_tag_type === 2).map((tag) => (
                  <div className="grid-item" key={tag.parse_tag_id}>
                    <div className="check-box-tag-impt">
                      <input
                        type="checkbox"
                        id={`motd-edit-chk-${tag.parse_tag_id}`}
                        className="cr-custom-checkbox-tags"
                        onChange={(e) => handleCheckboxChange(tag, e.target.checked)}
                        checked={selectedTags.some((t) => t.tag_id === tag.parse_tag_id && t.tag_value_id === 1)}
                      />
                      <label htmlFor={`motd-edit-chk-${tag.parse_tag_id}`}>{tag.parse_tag_name}</label>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
 
      {/* ── SECTION 2: Questions List ─────────────────────────────────────── */}
      <div className="create-ques-paper-ques-list-container-text" style={{ marginTop: 20 }}>
        <span>QUESTIONS LIST</span>
      </div>
      <div className="create-ques-paper-ques-list-container" style={lockedSection}>
        <TableDetailsQuesList
          selectedTags={memoizedTags}
          filters={memoizedFilters}
          setMessageBox={setMessageBox}
          messageBox={messageBox}
          setIsMessageBoxVisible={setIsMessageBoxVisible}
          setActiveImg={setActiveImg}
          setNoTimeSet={setNoTimeSet}
          dataClient={null}
          setSelectedQuestions={setSelectedQuestions}
          setSelectedHeaders={setSelectedHeaders}
          setDifficultyCount={setDifficultyCount}
          userId={userId}
          showFlagModal={showFlagModal}
          setShowFlagModal={setShowFlagModal}
          subjectId={selectedSubjectId ? parseInt(selectedSubjectId) : null}
          courseId={selectedCourseId  ? parseInt(selectedCourseId)  : null}
          scopeRefIds={[0]}
          setReportDashboardData={setReportDashboardData}
          reportDashboardData={reportDashboardData}
          draftData={null}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          selectedQuestions={selectedQuestions}
          activeSubjectId={activeSubjectKey}
          setVersion={handleVersionChange}
          excludeRepeatCount={0}
          clientBranchId={clientBranchId}
          scopeId={0}
          loadingTab={false}
          setLoadingTab={() => {}}
          isReadOnly={!isEditMode}
        />
      </div>
 
      {/* ── SECTION 3: Selected Questions ────────────────────────────────── */}
      <div className="create-ques-paper-ques-selected-container-text" style={{ marginTop: 20 }}>
        <span>SELECTED QUESTIONS</span>
      </div>
      <div className="create-ques-paper-ques-selected-container" style={lockedSection}>
        <TableDetailsSelectedQues
          selectedQuestions={stableSelectedQuestions}
          selectedHeaders={selectedHeaders}
          selectedSections={1}
          setSectionWiseQuestions={setSectionWiseQuestions}
          selecteSectionTypeID={1}
          setIsMessageBoxVisible={setIsMessageBoxVisible}
          setActiveImg={setActiveImg}
          setMessageBox={setMessageBox}
          allQuesList={reportDashboardData}
          setSelectedQuestions={setSelectedQuestions}
          selectedRows={allSelectedRows}
          setSelectedRows={setSelectedRows}
          draftData={null}
          isReadOnlyMode={!isEditMode}
          setDifficultyCount={setDifficultyCount}
          activeSubjectId={activeSubjectKey}
          version={version}
          setVersion={handleVersionChange}
          sectionWiseQuestions={sectionWiseQuestions}
          customSectionOptions={customSectionOptions}
          sectionColumnLabel="Schedule Date"
          numQuestionsPerDate={MAX_QUESTIONS}
        />
      </div>
    </div>
  );
}